import React from 'react';

import { StyledIconButton } from './styles';
import { TIconButton } from './types';

export const IconButton = React.forwardRef<HTMLButtonElement, TIconButton>(
  ({ disableRipple = true, variant = 'outlined', ...otherProps }, ref) => {
    return (
      <StyledIconButton
        ref={ref}
        disableRipple={disableRipple}
        variant={variant}
        {...otherProps}
      />
    );
  }
);

IconButton.displayName = 'IconButton';
